// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import $ from 'jquery'
import router from './router'
import VueWorker from 'vue-worker'
import VueRouter from 'vue-router'
import locale from 'element-ui/lib/locale/lang/en'
import chzlocale from 'element-ui/lib/locale/lang/zh-CN'

import 'element-ui/lib/theme-chalk/index.css'

const lang = (localStorage.getItem('userinfo') && JSON.parse(localStorage.getItem('userinfo')).roleid == 2 )? locale : chzlocale
// console.log('main.js', JSON.parse(localStorage.getItem('userinfo')).roleid, lang)
// vue中导出excel表格模板
import FileSaver from 'file-saver'  
import XLSX from 'xlsx'
import { Message } from 'element-ui';
 
Vue.prototype.$message = Message;
// 将excel表格模板设置全局
Vue.prototype.$FileSaver = FileSaver; 
Vue.prototype.$XLSX = XLSX;

Vue.config.productionTip = false
Vue.use(ElementUI, {
    locale: lang
})
Vue.use(VueRouter)
Vue.use(VueWorker)
// Vue.use(VueHighcharts, { Highcharts });

/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})